<!--
* UIID: UI-CAAS-INT-100
* UI Name: Integration SET
* Modify Date: 2020/06/16
-->
<template>
  <div class="container int-container">
    <!-- Title-Page -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{$t('lbl.integrationSET.page_header')}}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Message-Name -->
    <v-row class="page-text-int" no-gutters>
      <v-col cols="12" lg="2" md="2"></v-col>
      <v-col cols="12" lg="5" md="5" class="pt-0 pb-0 pl-50">
        <v-toolbar-title class="int-info">{{$t('lbl.integrationSET.smartLinkTxt')}}</v-toolbar-title>
      </v-col>
      <v-col cols="12" lg="5" md="5" class="pt-0 pb-0 text-right">
        <v-btn class="btn btn-setup" color="primary">
          <v-icon small color="white" class="mr-1">fa fa-cog</v-icon>
          {{$t('btn.integrationSET.setUpSet')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="ml-0 mr-0">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col cols="12" lg="2" md="2" class="left-grid-content">
            <v-row class="ma-0">
              <v-col class="pd-search-int" cols="12">
                <v-text-field
                  v-model="searchMessageName"
                  class="color-search-int search-button-data-analysis-table"
                  :placeholder="$t('lbl.common.conditionSearch.findbyMessageName')"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>

            <!-- Treeview-Message-Name -->
            <v-row>
              <!-- // 2021.5.19 203728 Issue 53 No display spinner -->
              <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
              <v-col cols="12">
                <v-treeview
                  :items="layoutGroupData"
                  :open-all="true"
                  :search="searchMessageName"
                  :active.sync="selected"
                  activatable
                  active-class="text--lighten-2"
                  expand-icon
                  open-on-click
                  return-object
                  dense
                  rounded
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="item.children">{{ open ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                    <v-icon
                      v-else
                      :color="$vuetify.theme.dark ? '#86D9FD' : '#18236D'"
                    >{{ 'mdi-file-document-outline' }}</v-icon>
                  </template>
                </v-treeview>
              </v-col>
            </v-row>
          </v-col>

          <!-- Right-Component -->
          <v-col cols="12" lg="10" md="10" class="right-grid-content pb-0 pt-0 pr-0 pl-50">
            <v-card>
              <setDetail :items="listData" :items2="listDatas" :tmpId="tmpId"></setDetail>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import setDetail from '@/vue-caas/views/integrationset/IntegrationSetDetail.vue'
// 2021.5.19 203728 Issue 53
import { mapState } from "vuex";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";

export default {
  components: {
    setDetail,
    // 2021.5.19 203728 Issue 53
    SystemProgress,
  },
  data(){
    return{
    layoutGroupData: [],
    selected: [],
    listData: [],
    listDatas: [],
    tmpId: '',
    fileContent: '',
    searchMessageName: '',
    message_id: '',
    version: '',
    // 2021.5.19 203728 Issue 53
    isLoading: false,
  }},

  computed: {
    // 2021.5.19 203728 Issue 53
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },

  watch: {
    selected() {
      const tmpId = this.selected[0].id;
      this.message_id = this.selected[0].message_id;
      this.version = this.selected[0].version;
      this.tmpId = tmpId;
      this.fetchData();
      this.readFileContent();
    },
  },
  
  methods: {
    fetchData() {
      // 2021.5.19 203728 Issue 53
      this.isLoading = true;
      // 2021.12.6 203728 change condition in Integration Set
      this.$store.dispatch('getIntegrationSetDetail', {tmpId: this.tmpId, message_id: this.message_id, version: this.version}).then(() => {
        this.listData = this.$store.getters.integrationSetDetail;
        // 2021.5.19 203728 Issue 53
        this.isLoading = false;
      }).catch((ex) => {
        // 2021.5.19 203728 Issue 53
        this.isLoading = false;
      });
    },
     readFileContent(){
      // 2021.5.19 203728 Issue 53
      this.isLoading = true;
      this.$store.dispatch('getReadFileContent', {tmpId: this.tmpId, message_id: this.message_id, version: this.version}).then(() => {
        this.listDatas = this.$store.getters.integrationSetContent;
        // 2021.5.19 203728 Issue 53
        this.isLoading = false;
      }).catch((ex) => {
        // 2021.5.19 203728 Issue 53
        this.isLoading = false;
      });
    }, 
  },

  created() {
    this.$store.dispatch('getIntegrationSetList').then(() => {
      this.layoutGroupData = this.$store.getters.integrationSetList;
      this.tmpId = this.layoutGroupData[0].children[0].id;
      this.message_id = this.layoutGroupData[0].children[0].message_id;
      this.version = this.layoutGroupData[0].children[0].version;
      this.fetchData();
      this.readFileContent();
      this.openAll = true;
    });
  },
}
</script>

<style lang="scss">
.int-container .v-treeview.analyzedTree .v-treeview-node__children .v-treeview-node__level{
  display: none;
}
.page-text-int{
  margin-bottom: 10px;
}
.pd-search-int{
  padding: 40px 15px 15px;
}
.int-info{
  height: 30px;
  font-size: 18px;
}
.theme--light .int-info{
  color: #12083F
}
.theme--dark .int-info{
  color: #BBBBBB
}
.int-info-col{
  padding: 0px 0px 5px;
}
.v-application--is-ltr .v-treeview-node__toggle {
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  display: none;
}
.int-container .v-treeview-node__label{
  font-size: 14px !important;
}
.int-container .v-treeview-node__children .v-treeview-node__root .v-treeview-node__label{
  font-size: 12px !important;
}
.pl-50{
  padding-left: 50px !important;
}
.right-grid-content{
  height: 740px;
  .theme--dark.v-card{
    border:none;
  }
  .theme--light.v-card{
    border:1px solid #F0F7FB;
    border-radius: 3px;
  }
}
.left-grid-content input::placeholder{
  font-size: 14px;
}
.left-grid-content .v-treeview{
  min-height: 558px;
  max-height: 559px;
  overflow-y:auto;
  overflow-x: auto;
  .v-treeview-node__children .v-treeview-node__level{
    display: none;
  }
  .v-treeview-node__root{
    width: calc(100% - 5px);
  }
}
.grid-right-Int{
  padding: 40px 15px 15px;
  border-radius: 3px;
}
.grid-content-Int{
  padding: 35px 40px 25px;
  .analyzedTree.v-treeview {
    height: 554px;
    max-width: 100%;
    overflow-x: auto;
    .v-treeview-node__root{
      width: 300px;
    }
  }
  .edi-wrap-content-left{
    height: auto !important;
    padding: 10px 15px !important;
    .analyzedTree .v-treeview-node__label {
      font-size: 11px !important;
      font-weight: bold;
    }
  }
  .table-sample-content .list-table .v-data-table__wrapper{
    min-height: 552px;
    max-height:553px;
    overflow-y: auto;
  }
  button.expand-all-tree-view-button{
    margin: 0px 0px 10px !important;
    height: 20px !important;
    font-size: 10px;
  }
}
.table-sample-content{
  padding: 40px 15px 10px 15px !important;
}
.grid-data-padding{
  padding-left: 24px !important;
}
.theme--light {
  .left-grid-content{
    background: #FAFCFF;
    border: 1px solid #F0F7FB;
  }
  .grid-content-Int{
    background: #FAFCFF;
    .table-sample-content, .edi-wrap-content-left{
      background: #EDF3FC;
    }
  }
  .color-search-int{
    border: 1px solid #D4D5D7;
    input{
      color: #303134
    }
  }
  .table-sample-content{
    border: 1px solid #F0F7FB;
    border-radius: 3px
  }
}
.theme--dark{
  .table-sample-content .v-data-table__wrapper::-webkit-scrollbar {
    width: 17px;
  }
  .table-sample-content .v-data-table__wrapper::-webkit-scrollbar-track  {
      background-color: #595B64;
  }
  .table-sample-content .v-data-table__wrapper::-webkit-scrollbar-thumb {
      background-color: #DEDFE0;
  }
  .table-sample-content .v-data-table__wrapper::-webkit-scrollbar-corner{
    background-color: #595B64;
  }
  .grid-content-Int .edi-wrap-content-left{
    border-color: #232329;
    background: #232329;
  }
  .grid-content-Int, .left-grid-content{
    background: #3b3e49;
    border: none;
  }
  .table-sample-content{
    background: #232329;
    border: 1px solid transparent;
    border-radius: 3px
  }
  .left-grid-content .v-input__slot, .int-info-col .v-input__slot{
    background: #2a2c35 !important;
    font-size: 14px;
  }
  .left-grid-content  .v-treeview::-webkit-scrollbar {
    width: 17px;
  }
  .left-grid-content  .v-treeview::-webkit-scrollbar-track  {
      background-color: #595B64;
  }
  .left-grid-content  .v-treeview::-webkit-scrollbar-thumb {
      background-color: #DEDFE0;
  }
  .left-grid-content  .v-treeview::-webkit-scrollbar-corner{
    background-color: #595B64;
  }
}
</style>